<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加职工</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">


                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">登录账号</div>
                        <el-input v-model="add_loginName" placeholder="请输入登录账号"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">登录密码</div>
                        <el-input v-model="add_password" placeholder="请输入登录密码" show-password></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">姓名</div>
                        <el-input v-model="add_realName" placeholder="请输入姓名"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择角色</div>
                        <el-select v-model="add_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleCode"
                                    :label="item.name"
                                    :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">手机</div>
                        <el-input v-model="add_phone" placeholder="请输入手机"></el-input>
                    </el-col>
                    <!-- <el-col :span="12" class="item">
                        <div class="label">选择政府</div>
                        <el-select v-model="add_governmentCode" @change="changeGovernment" style="width:100%">
                            <el-option
                                    v-for="item in governmentList"
                                    :key="item.governmentCode"
                                    :label="item.name"
                                    :value="item.governmentCode">
                            </el-option>
                        </el-select>
                    </el-col> -->
                </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Add',
        props: [],
        data() {
            return {

                loading: false,

                add_loginName:'',
                add_password:'',
                add_realName:'',
                add_roleCode:'',
                add_phone:'',
                // add_governmentCode:'',
                add_zonCode:'',

                roleList:null,
                governmentList:null,

            }
        },
        methods: {
            init(){
              console.log("Add init");

              this.add_loginName = '';
              this.add_password = '';
              this.add_realName = '';
              this.add_roleCode = '';
              this.add_phone = '';

              this.getRoleList();
              this.getGovernmentList();

            },
            closeSelf() {
                this.$emit("closeAdd");
            },

            confirm(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }



                if(this.add_loginName == ''){
                    this.loading = false;
                    return;
                }
                if(this.add_password == ''){
                    this.loading = false;
                    return;
                }
                if(this.add_realName == ''){
                    this.loading = false;
                    return;
                }
                if(this.add_phone == ''){
                    this.loading = false;
                    return;
                }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Staff/Add',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        loginName: this.add_loginName,
                        password:this.add_password,
                        realName:this.add_realName,
                        roleCode:this.add_roleCode,
                        phone:this.add_phone,
                        // governmentCode:this.add_governmentCode,
                        zonCode:'',
                    }

                }).then( (response)=> {
                    console.log(response.data);
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeAdd");
                        this.$emit("getList");
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },

            changeRole:function(selVal){
                this.add_roleCode = selVal;
            },
            changeGovernment:function(selVal){
                this.add_governmentCode = selVal;
            },

            getRoleList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Role/ListGovRole",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            console.log(response.data.data)
                            var roleValue = response.data.data;

                            //roleValue=this.remove(roleValue,'商家')
                            //roleValue=this.remove(roleValue,'管理员')
                            //roleValue=this.remove(roleValue,'服务人员')
                            //roleValue=this.remove(roleValue,'超级管理员')
                            //roleValue=this.remove(roleValue,'客服')

                          roleValue = this.remove2(roleValue);

                            this.roleList=roleValue
                            //this.add_roleCode = this.roleList[0].roleCode;
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
             remove(array,name){
                for (var i = 0; i < array.length; i++) {
                    if (array[i].name == name){
                        array.splice(i, 1);
                        console.log(array)
                        return array
                    }
                    
                }
            },
          remove2(array){
            for (var i = array.length-1; i >= 0; i--) {
              if (array[i].name != '系统管理员'){
                array.splice(i, 1);
              }
            }
            return array
          },
            getGovernmentList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Government/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    console.log(response.data);
                    if(response.data.error == 0){
                        this.governmentList = response.data.data;
                        //this.add_governmentCode = this.governmentList[0].governmentCode;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>


<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 500px;
    }
    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
